import { SVGProps } from '@components/Icon/types';

export const Save2 = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2.3, 2.3)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3545 0C13.7759 0 14.2172 0.158438 14.5264 0.449219L14.5273 0.448242L18.7822 4.21191L18.8135 4.24121C19.1079 4.53568 19.4004 4.97631 19.4004 5.55469V16.5186C19.4002 18.1049 18.1049 19.4003 16.5186 19.4004H2.88184C1.29544 19.4003 0.000199308 18.1049 0 16.5186V2.88184C9.60048e-05 1.29538 1.29538 9.61343e-05 2.88184 0H13.3545ZM2.88184 1.40039C2.06857 1.40049 1.40049 2.06857 1.40039 2.88184V16.5186C1.40059 17.3317 2.06864 18.0009 2.88184 18.001H3.27246V11.6094C3.27251 10.6229 4.07706 9.81854 5.06348 9.81836H14.3359C15.3225 9.81836 16.1269 10.6228 16.127 11.6094V17.5439C16.1269 17.7196 16.06 17.8781 15.9531 18.001H16.5186C17.3317 18.0009 17.9998 17.3317 18 16.5186V5.55469C18 5.47967 17.9658 5.37698 17.8291 5.23828L13.9463 1.80371V4.51855C13.9462 5.50491 13.1416 6.30931 12.1553 6.30957H5.60938C4.62288 6.30952 3.81846 5.50504 3.81836 4.51855V1.40039H2.88184ZM5.06348 11.2188C4.85025 11.2189 4.6729 11.3961 4.67285 11.6094V18.001H14.9014C14.7946 17.8781 14.7276 17.7195 14.7275 17.5439V11.6094C14.7275 11.396 14.5493 11.2188 14.3359 11.2188H5.06348ZM5.21875 4.51855C5.21885 4.73185 5.39607 4.90913 5.60938 4.90918H12.1553C12.3684 4.90891 12.5458 4.73171 12.5459 4.51855V1.40039H5.21875V4.51855Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'save-2';
